enum NotificationsChannel {
  Sms = "1",
  Email = "2",
}

export default NotificationsChannel;
